// The new trainer's look (shared/looks.ts): skin tone, hair and a free outfit, chosen after their name and before
// their starter. Free, and changed any time later on the Outfits tab. Shown while TrainerDTO.lookPick is set; the
// server clears it with the { t: 'look' } message that Continue sends.
import { S } from './state.ts';
import type { ClientMsg } from '../shared/protocol.ts';
import { lookPicker, lookDraft, lookPickerClick, lookSave, type LookDraft } from './lookpicker.ts';

let host: HTMLElement | null = null;
let draft: LookDraft | null = null;
let sent = false;

function draw() {
  host!.querySelector('.lp-body')!.innerHTML = lookPicker(draft!);
}

export function renderLookPick(send: (m: ClientMsg) => void) {
  const want = !!S.trainer?.lookPick && !S.trainer.namePick && !sent;
  if (!want) { if (host) { host.remove(); host = null; } if (!S.trainer?.lookPick) { sent = false; draft = null; } return; }
  if (host) return;
  // Starts in a free outfit that shows the hair, not the hooded Traveler's Cloak.
  draft ??= lookDraft({ outfit: 'wayfarer' });
  host = document.createElement('div');
  host.className = 'scrim sp-scrim';
  host.innerHTML = `<div class="dialog lp-pick" role="dialog" aria-modal="true" aria-labelledby="lp-title">
    <h3 id="lp-title">Choose your look</h3>
    <div class="lp-body"></div>
    <div class="actions"><button class="btn gold" data-lp-go>Continue</button></div>
  </div>`;
  host.addEventListener('click', (e) => {
    const t = e.target as HTMLElement;
    const b = t.closest<HTMLElement>('[data-act^="look-"]');
    if (b) { e.stopPropagation(); if (lookPickerClick(draft!, b)) draw(); return; }
    if (t.closest('[data-lp-go]')) {
      sent = true;
      lookSave(send, draft!);
      host?.remove(); host = null;
    }
  });
  document.body.appendChild(host);
  draw();
}
